import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import { useState } from "react";
import "leaflet/dist/leaflet.css";



function LocationMarker({ position, setPosition }) {
  useMapEvents({
    click(e) {
      setPosition(e.latlng);
    },
  });

  return position ? <Marker position={position} /> : null;
}

export default function ExpressLocationModal({ onConfirm, onClose }) {
  const [position, setPosition] = useState(null);

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>Select Delivery Location</h3>

        <MapContainer
          center={[35.6892, 51.389]}
          zoom={12}
          style={{
            height: "400px",
            width: "100%",
          }}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

          <LocationMarker position={position} setPosition={setPosition} />
        </MapContainer>

        {position && (
          <div>
            <p>Latitude: {position.lat}</p>

            <p>Longitude: {position.lng}</p>
          </div>
        )}

        <button disabled={!position} onClick={() => onConfirm(position)}>
          Confirm Location
        </button>

        <button onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
}
